import { Button, FormField, Input } from "@wix/design-system";
import React, { useContext, useRef, useState } from "react";
import { generateId, VIDEO_TYPE } from "./../../ricos-content";
import { EditorContext, RicosContext } from "./../../ricos-context";
import { containsUrl } from "./../../_shared/link/contains-url";
import { ReactPlayer } from "./../../wix-react-player";
import { MEDIA_POPOVERS_BUTTONS_NAMES_BI } from "./../../wix-rich-content-common";
import { EMBED_TAB_SUBMIT_BUTTON, EMBED_TAB_URL_INPUT } from "../data-hooks";
import classes from "./embed-video-scss";
import { isVideoMetadata } from "./is-video-metadata";
const EmbedVideo = ({
  componentData,
  helpers,
  closeModal,
  logBi,
  ...props
}) => {
  const { t } = useContext(RicosContext);
  const { getPublicCommands } = useContext(EditorContext);
  const [url, setUrl] = useState(
    componentData?.video?.src?.id ? "" : componentData?.video?.src?.url || ""
  );
  const [submittedInvalidUrl, setSubmittedInvalidUrl] = useState(false);
  const inputRef = useRef(null);
  const updateVideoMetadata = (videoNodeId, metadata) => {
    getPublicCommands().updateBlock?.(
      videoNodeId,
      VIDEO_TYPE,
      {
        thumbnail: {
          src: { url: metadata.thumbnail_url },
          width: metadata.thumbnail_width,
          height: metadata.thumbnail_height
        },
        title: metadata.title
      }
    );
  };
  const onUrlUploadClick = () => {
    helpers.onPluginsPopOverClick?.({
      pluginId: VIDEO_TYPE,
      buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.embed
    });
    logBi({ dataHook: EMBED_TAB_SUBMIT_BUTTON });
    if (!url || !ReactPlayer.canPlay(url)) {
      setSubmittedInvalidUrl(true);
      inputRef.current?.focus();
      return;
    }
    const videoData = (() => {
      const updatedVideo = { ...componentData.video, src: { url } };
      return props.nodeId ? { containerData: componentData.containerData, video: updatedVideo } : { ...componentData, video: updatedVideo };
    })();
    const nodeId = props.nodeId || generateId();
    setTimeout(() => {
      props.nodeId === void 0 ? getPublicCommands().insertBlockWithBlankLines(VIDEO_TYPE, { ...videoData, id: nodeId }) : getPublicCommands().setBlock(props.nodeId, VIDEO_TYPE, videoData);
    });
    if (helpers?.onVideoSelected) {
      helpers.onVideoSelected(url, (data) => {
        const { oembed } = data;
        if (typeof oembed !== "object" || oembed === null || !isVideoMetadata(oembed)) {
          return;
        }
        return updateVideoMetadata(nodeId, oembed);
      });
    }
    closeModal();
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormField,
    {
      label: t("VideoModal_Embed_Title"),
      maxLines: 2,
      status: submittedInvalidUrl ? "error" : void 0,
      statusMessage: submittedInvalidUrl ? t("SoundCloudUploadModal_Input_InvalidUrl") : void 0
    },
    /* @__PURE__ */ React.createElement(
      Input,
      {
        inputRef: (ref) => {
          inputRef.current = ref;
        },
        className: classes.input,
        type: "url",
        id: "dropdown-text-input",
        autocomplete: "off",
        dataHook: EMBED_TAB_URL_INPUT,
        value: url,
        textOverflow: "ellipsis",
        onChange: (e) => {
          setSubmittedInvalidUrl(false);
          setUrl(e.target.value);
          logBi({ dataHook: EMBED_TAB_URL_INPUT, value: e.target.value });
        },
        placeholder: t("EmbedURL_Placeholder"),
        onBlur: () => {
          if (url && !containsUrl(url)) {
            setSubmittedInvalidUrl(true);
          }
        },
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            onUrlUploadClick();
          }
        }
      }
    )
  ), /* @__PURE__ */ React.createElement(Button, { dataHook: EMBED_TAB_SUBMIT_BUTTON, onClick: onUrlUploadClick, size: "small" }, t("VideoModal_Embed_ButtonText")));
};
export {
  EmbedVideo
};
//# sourceMappingURL=embed-video.js.map
